import HistoryCarUsage from './HistoryCarUsage'

export default HistoryCarUsage
